import React from 'react';

export function YugaWheelSVG({ stage = "satya" }) {
  return (
    <svg viewBox="0 0 100 100">
      <defs>
        <radialGradient id="ygCore" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="var(--yuga-glow)" stopOpacity="1" />
          <stop offset="100%" stopColor="var(--yuga-glow)" stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="48" fill="url(#ygCore)" opacity="0.25" />
      <g className="ring" stroke="var(--yuga-glow)" fill="none" strokeWidth="0.6" opacity="0.8">
        <circle cx="50" cy="50" r="46" />
        <circle cx="50" cy="50" r="38" strokeDasharray="2 3" />
        <circle cx="50" cy="50" r="28" />
        {Array.from({ length: 16 }).map((_, i) => {
          const a = (i / 16) * Math.PI * 2;
          const x1 = 50 + Math.cos(a) * 28;
          const y1 = 50 + Math.sin(a) * 28;
          const x2 = 50 + Math.cos(a) * 46;
          const y2 = 50 + Math.sin(a) * 46;
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />;
        })}
      </g>
      <circle cx="50" cy="50" r="6" fill="var(--yuga-glow)" />
      <circle cx="50" cy="50" r="2.5" fill="var(--paper)" />
      <g transform={`rotate(${stage === 'satya' ? 0 : stage === 'treta' ? 90 : stage === 'dvapara' ? 180 : 270} 50 50)`}>
        <circle cx="50" cy="8" r="3" fill="var(--paper)" />
      </g>
    </svg>
  );
}
